import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { forwardRef, createElement } from 'react';
import { classNames } from '../../helpers/classnames.js';

var tagMap = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    body1: 'p',
    body2: 'p',
    body3: 'p',
    subtitle1: 'span',
    subtitle2: 'span',
    subtitle3: 'span',
    caption: 'span',
    overline: 'span',
    productName: 'span'
};
var Typography = forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'body1' : _b, className = _a.className, rest = __rest(_a, ["variant", "className"]);
    return createElement(tagMap[variant], __assign({ className: classNames('dsb_typography', "dsb_typography__".concat(variant), className), ref: ref }, rest));
});

export { Typography };
